<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-12  flex-column" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"border-radius: 16px;"' class="shadow mb-4 h-100" >
                <template #default>   <m-h3 v-bind='{...{},...{}}' :style='""' class="font-weight-bold col-12" >
                <template #default>ارسال درخواست   </template>
                </m-h3><m-form-single-1 v-bind='{...{"itemClass":"col-lg-12 mb-3","formId":2,"redirectToDashboard":false,"redirectDirectLink":"https:\/\/omidnoorani.ir\/submit-form"},...{}}' :style='""' class="form-single-1-wrapper " ></m-form-single-1></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH3 from '@moeinmdn/miw-alpha-components/src/package/Tags/H3'; import mFormSingle1 from '@moeinmdn/miw-alpha-components/src/package/Form/FormSingle/FormSingle1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH3,mFormSingle1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
